import BondsTile from './BondsTile';
import BondsTileWithFallback from './BondsTileWithFallback';

export { BondsTile, BondsTileWithFallback };
export default BondsTile;
